// src/components/CookieBanner.tsx
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const Banner = styled(motion.div)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.92);
  color: white;
  padding: 1.5rem 2rem;
  z-index: 9999;
  font-size: 0.95rem;
  backdrop-filter: blur(10px);
  border-top: 3px solid #990147;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Text = styled.p`
  margin: 0;
  line-height: 1.5;
  flex: 1;
  min-width: 300px;

  a {
    color: #cc3366;
    text-decoration: underline;
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 1rem;
  flex-shrink: 0;

  button {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
  }
`;

const AcceptBtn = styled.button`
  background: #990147;
  color: white;
  &:hover { background: #cc3366; }
`;

const SettingsBtn = styled.button`
  background: transparent;
  color: white;
  border: 2px solid white !important;
  &:hover { background: rgba(255,255,255,0.1); }
`;

const RejectBtn = styled.button`
  background: rgba(255,255,255,0.15);
  color: white;
  &:hover { background: rgba(255,255,255,0.25); }
`;

export const CookieBanner: React.FC = () => {
    const [show, setShow] = useState(false);
    const [showSettings, setShowSettings] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            setShow(true);
        }
    }, []);

    const acceptAll = () => {
        localStorage.setItem('cookie-consent', 'all');
        setShow(false);
        // Tu môžeš načítať Google Analytics, Facebook Pixel atď.
        loadGtag();
    };

    const acceptNecessary = () => {
        localStorage.setItem('cookie-consent', 'necessary');
        setShow(false);
    };

    const loadGtag = () => {
        // Príklad pre Google Analytics – odkomentuj ak používaš
        // window.dataLayer = window.dataLayer || [];
        // function gtag(...args: any[]) { window.dataLayer.push(args); }
        // gtag('js', new Date());
        // gtag('config', 'G-XXXXXXXXXX');
    };

    if (!show) return null;

    return (
        <AnimatePresence>
            <Banner
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 100, opacity: 0 }}
            >
                <Content>
                    <Text>
                        Používame cookies na zlepšenie používateľského zážitku a analýzu návštevnosti.
                        Viac informácií nájdete v našich{' '}
                        <a href="/ochrana-osobnych-udajov">Zásadách ochrany osobných údajov</a>.
                    </Text>

                    <Buttons>
                        <RejectBtn onClick={acceptNecessary}>
                            Len nevyhnutné
                        </RejectBtn>
                        <AcceptBtn onClick={acceptAll}>
                            Prijať všetko
                        </AcceptBtn>
                    </Buttons>
                </Content>
            </Banner>
        </AnimatePresence>
    );
};